export const drawerState = {
  addressDrawer: 'addressDrawer',
  attachedAddresses: 'attachedAddresses',
  addressBook: 'addressBook',
  groupsDrawer: 'groupsDrawer',
  createAddress: 'createAddress',
  closed: 'Closed',
  detail: 'detail',
}
